type IEventNames = string[]
export default class EventEmitter {
  private _listeners: { [key: string]: Array<Function> | null }
  private _eventNames: IEventNames
  private _passageEventNamePrefix: string

  constructor (eventName: IEventNames, passageEventNamePrefix?: string) {
    const prefix = passageEventNamePrefix || ''
    this._passageEventNamePrefix = prefix
    this._eventNames = eventName.map((evtName) =>
      prefix ? `${prefix}$${evtName}` : evtName,
    )
    this._listeners = {}

    this.addEventListener = this.addEventListener.bind(this)
    this.removeEventListener = this.removeEventListener.bind(this)
    this.removeAllEventListener = this.removeAllEventListener.bind(this)

    this.trigger = this.trigger.bind(this)
  }

  public addEventListener (eventName: string, handler: Function): () => void {
    const prefix = this._passageEventNamePrefix

    if (prefix && !eventName?.startsWith(prefix)) {
      return () => undefined
    }

    if (!prefix && !this._eventNames.includes(eventName)) {
      return () => undefined
    }

    const listeners = this._listeners[eventName] || []

    listeners.unshift(handler)
    this._listeners[eventName] = listeners

    const unbind = () => {
      const idx = listeners.indexOf(handler)
      if (idx > -1) {
        listeners.splice(idx, 1)
      }
    }

    return unbind
  }

  public removeEventListener (eventName: string, handler: Function): void {
    const listeners = this._listeners[eventName] || []
    const idx = listeners.indexOf(handler)
    if (idx > -1) {
      listeners.splice(idx, 1)
    }
  }

  public removeAllEventListener (eventName?: string) {
    if (eventName) this._listeners[eventName] = null
    return this
  }

  public trigger (eventName: string, ...event: any) {
    try {
      const prefix = this._passageEventNamePrefix
      const evtName = !prefix || eventName.startsWith(prefix) ? eventName : `${prefix}$${eventName}`
      const listeners: Function[] = ((this._listeners && this._listeners[evtName]) || [])

      listeners && listeners.slice().forEach((listener) => listener(...event))
    } catch (err) {
      // console.log(err)
    }
  }
}
